export const AIChatPreviewCard = ({ messages, inputValue, onInputChange, onSend, title }) => {
  return (
    <div className="card" data-testid="ai-chat-preview-card">
      <div className="card-head">
        <h3>{title}</h3>
        <span className="metric-badge badge-green">● Guided Engine Active</span>
      </div>
      <div className="card-body">
        <div className="ai-chat-box" data-testid="ai-chat-box">
          {messages.map((item, index) =>
            item.role === "agent" ? (
              <div className="ai-msg" key={`${item.role}-${index}`} data-testid={`ai-msg-${index}`}>
                <div className="ai-icon">🤖</div>
                <div className="ai-bubble">{item.text}</div>
              </div>
            ) : (
              <div className="user-msg" key={`${item.role}-${index}`} data-testid={`user-msg-${index}`}>
                <div className="user-bubble">{item.text}</div>
              </div>
            ),
          )}

          <div className="chat-input-row">
            <input
              className="chat-input"
              value={inputValue}
              onChange={(event) => onInputChange(event.target.value)}
              placeholder="Enter requested location context or details..."
              data-testid="ai-chat-input"
            />
            <button className="chat-send" onClick={onSend} data-testid="ai-chat-send-button">
              ➤
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
